import React, { Component } from 'react';
import axios from 'axios';
import utf8 from 'utf8';
import { Base64 } from 'js-base64';
import windows1256 from 'windows-1256';
import legacy_encoding from 'legacy-encoding';
import equals from 'deep-equal';

import DarkSelect from './DarkSelect.js';
import default_globe from './images/default_globe.png';

class EmbeddedModel extends Component {
    constructor(props) {
        super(props);

        this.baseConfig = {
          "co2": {
            "from": 1,
            "to": 2
          },
          "year": 1895,
          "grid": {
            "dims": {
              "lat": 10,
              "lon": 20.
            },
            "repr": "width"
          },
          "layers": 1,
          "iters": 1,
          "aggregate_lat": "none",
          "aggregate_level": "none",
          "temp_src": "arrhenius",
          "humidity_src": "arrhenius",
          "albedo_src": "landmask",
          "absorbance_src": "table",
          "pressure_src": "none",
          "CO2_weight": "mean",
          "H2O_weight": "mean"
        };
        this.history = [];
        this.historyIndex = -1;

        this.zoomRatings = [
          [-0.1, 0.1],
          [-0.4, 0.4],
          [-1, 1],
          [-2, 2],
          [-4, 4],
          [-8, 8],
          [-12, 12],
          [-20, 20],
        ]
        this.zoomIndex = 5;
        this.timeSegment = null;

        this.setModelMode = this.setModelMode.bind(this);
        this.currentConfig = this.currentConfig.bind(this);
        this.launchModelRun = this.launchModelRun.bind(this);
        this.writeRunSummary = this.writeRunSummary.bind(this);

        this.zoomIn = this.zoomIn.bind(this);
        this.zoomOut = this.zoomOut.bind(this);
        this.stepHistoryBackward = this.stepHistoryBackward.bind(this);
        this.stepHistoryForward = this.stepHistoryForward.bind(this);

        this.isEnabled = this.isEnabled.bind(this);
        this.disable = this.disable.bind(this);
        this.enable = this.enable.bind(this);
        this.timeSegmentChange = this.timeSegmentChange.bind(this);
    }

    componentDidMount() {
        this.timeSegment = document.querySelector(".season-box");
        this.disable(this.timeSegment);
        this.summaryComponent = document.querySelector(".summary-frame p:last-child");

        let historyButtons = document.querySelectorAll(".model-hist");
        for (var i = 0; i < historyButtons.length; i++) {
            this.disable(historyButtons[i]);
        }
    }

    setModelMode(mode) {
      if (mode === 'table') {
        this.baseConfig.temp_src = "arrhenius";
        this.baseConfig.humidity_src = "arrhenius";
        this.baseConfig.absorbance_src = "table";

        this.baseConfig.year = 1895;
        this.baseConfig.CO2_weight = "mean";
        this.baseConfig.H2O_weight = "mean";
      } else if (mode === 'modern') {
        this.baseConfig.year = 1895;
        this.baseConfig.temp_src = "arrhenius";
        this.baseConfig.humidity_src = "arrhenius";
        this.baseConfig.pressure_src = "ncar";
        this.baseConfig.absorbance_src = "modern";
      } else {
        this.baseConfig.layers = 17;
        this.baseConfig.year = 2017;

        this.baseConfig.temp_src = "ncar";
        this.baseConfig.humidity_src = "ncar";
        this.baseConfig.pressure_src = "ncar";
        this.baseConfig.absorbance_src = "multilayer";
      }
    }

    currentConfig() {
        let config = JSON.parse(JSON.stringify(this.baseConfig));
        config.scale = this.zoomRatings[this.zoomIndex];
        config.pressure_src = this.baseConfig.absorbance_src === 'table'
                              ? 'none'
                              : 'ncar';

        return config;
    }

    historyConfig() {
        let config = this.history[this.historyIndex];
        config.scale = this.zoomRatings[this.zoomIndex];

        return config;
    }

    writeRunSummary(config) {
        let modeText = "";
        let configMode = this.baseConfig.absorbance_src;
        if (this.baseConfig.absorbance_src === 'table') {
            modeText = "Legacy";
        } else {
            modeText = configMode.charAt(0).toUpperCase() + configMode.slice(1);
        }

        let summary = "CO2 Multiplier: " + config.co2.to
                      + "</br>Data: " + modeText
                      + "</br>Grid: " + config.grid.dims.lon
                                   + "x" + config.grid.dims.lat
                      + "</br>Atm. Layers: " + config.layers
                      + "</br>Iterations: " + config.iters;

        this.summaryComponent.innerHTML = summary;
    }

    launchModelRun(e) {
        let config = this.currentConfig();

        let lastIndex = -1;
        let length = this.history.length;
        for (var i = 0; i < length; i++) {
            if (equals(this.history[i], config)) {
                lastIndex = i;
                break;
            }
        }

        if (lastIndex != -1) {
            this.history.splice(lastIndex, 1);
        }

        this.historyIndex = this.history.length - 1;
        this.history.push(config);
        this.enable(this.refs.next);

        console.log(lastIndex);
        console.log(this.history);
        this.stepHistoryForward(e);
        console.log(config);
    }

    retrieveModelImage(config) {
        let urlBase = "/~arrhenius/api";
        let url = urlBase + "/model/delta_t/"
                          + this.timeSegment.getAttribute('value');

        // Accept data as a blob to prevent failure to decode.
        axios.post(url, config).then((response) => {
            // let reader = new FileReader();
            const image = `data:image/png;base64, ${response.data}`;
            console.log(image);
            this.refs.mainImg.src = image;
            this.writeRunSummary(config);

            // readAsDataURL automatically encodes to Base64, which is the
            // required format for <img> data.
            // reader.onloadend = () => {
            //   let data = reader.result;
            //   console.log("Model Image Run:");
            //   console.log(data);
            //   this.refs.mainImg.src = data;
            //   this.writeRunSummary(config);
            // }
            //
            // reader.readAsDataURL(response.data);
        }).catch((error) => {
            console.log(error);
        });
    }

    disable(component) {
        if (!component.classList.contains("disabled")) {
            component.classList.add("disabled");
        }
    }

    enable(component) {
        if (component.classList.contains("disabled")) {
            component.classList.remove("disabled");
        }
    }

    isEnabled(component) {
      return !component.classList.contains("disabled");
    }

    zoomIn(e) {
        if (this.isEnabled(this.refs.zoomIn)) {
            this.zoomIndex--;
            this.enable(this.refs.zoomOut);
            if (this.zoomIndex == 0) {
                this.disable(this.refs.zoomIn);
            }

            let config = this.historyConfig();
            this.retrieveModelImage(config);
        }
    }

    zoomOut(e) {
        if (this.isEnabled(this.refs.zoomOut)) {
            this.zoomIndex++;
            this.enable(this.refs.zoomIn);
            if (this.zoomIndex == this.zoomRatings.length - 1) {
                this.disable(this.refs.zoomOut);
            }

            let config = this.historyConfig();
            this.retrieveModelImage(config);
        }
    }

    stepHistoryBackward(e) {
        e.preventDefault();

        if (this.isEnabled(this.refs.prev)) {
            this.historyIndex--;
            this.enable(this.refs.next);
            if (this.historyIndex == 0) {
                this.disable(this.refs.prev);
            }

            let config = this.historyConfig();
            this.retrieveModelImage(config);
        }
    }

    stepHistoryForward(e) {
        e.preventDefault();

        if (this.isEnabled(this.refs.next)) {
            this.historyIndex++;
            console.log(this.history);
            if (this.history.length > 1) {
                this.enable(this.refs.prev);
            }

            if (this.historyIndex == this.history.length - 1) {
                this.disable(this.refs.next);
            }

            console.log(this.historyIndex);
            let config = this.historyConfig();
            this.retrieveModelImage(config);
        }
    }

    timeSegmentChange(e) {
        e.preventDefault();

        let component = null;
        if (e.target.classList.contains("season-box")) {
          component = e.target;
        } else if (e.target.parentElement.classList.contains("season-box")) {
          component = e.target.parentElement;
        }

        this.enable(this.timeSegment);
        this.disable(component);
        this.timeSegment = component;

        let config = this.historyConfig();
        this.retrieveModelImage(config);
    }

    render() {
        return (
          <div className="model-container">
            <div className="viewscreen-row d-flex align-items-end flex">
              <div className="control-column d-flex flex-column align-items-end justify-content-end align-self-stretch">
                <div className="vis-column"/>
                <div id="data-src" className="model-opt d-flex select-opt">
                  <div className="opt-head align-middle">
                    Data
                  </div>
                  <DarkSelect options={[["Legacy", "table"], ["Modern", "modern"], ["Multilayer", "multilayer"]]}
                              minorHeight="30"
                              slideSpeed="240"
                              changeSelection={(text) => this.setModelMode(text)}/>
                  <div className="opt-column"/>
                </div>
                <div id="grid" className="model-opt d-flex">
                  <div className="opt-head align-middle">
                    Grid
                  </div>
                  <input id="width-input"
                         className="opt-numeric"
                         type="number"
                         placeholder="20"
                         defaultValue={this.baseConfig.grid.dims.lon}
                         onChange={(e) => this.baseConfig.grid.dims.lon = parseFloat(e.target.value)}
                  />
                  <div className="opt-head align-middle">
                    by
                  </div>
                  <input id="height-input"
                         className="opt-numeric"
                         type="number"
                         placeholder="10"
                         defaultValue={this.baseConfig.grid.dims.lat}
                         onChange={(e) => this.baseConfig.grid.dims.lat = parseFloat(e.target.value)}
                  />
                  <div className="opt-head align-middle">
                    Degrees
                  </div>
                </div>
                <div id="atm-multiplier" className="model-opt d-flex">
                  <div className="opt-head align-middle">
                    CO<sub>2</sub> Multiplier
                  </div>
                  <input id="C02-input"
                         className="opt-numeric"
                         type="number"
                         placeholder="1"
                         defaultValue={this.baseConfig.co2.to}
                         onChange={(e) => this.baseConfig.co2.to = parseFloat(e.target.value)}
                  />
                  <div className="opt-column"/>
                </div>
                <div id="iters" className="model-opt d-flex">
                  <div className="opt-head align-middle">
                    Feedback Repeats
                  </div>
                  <input id="iters-input"
                         className="opt-numeric"
                         type="number"
                         placeholder="1"
                         defaultValue={this.baseConfig.iters}
                         onChange={(e) => this.baseConfig.iters = parseInt(e.target.value)}
                  />
                  <div className="opt-column"/>
                </div>
                <div className="vis-column"/>
              </div>
              <div className="viewscreen-container">
                <img className="viewscreen"
                     ref="mainImg"
                     src={default_globe}
                />
                <div className="viewscreen-opts d-flex flex-fill">
                  <div className="season-bars d-flex align-items-stretch flex-grow-1">
                    <div className="season-box"
                         value="0"
                         onClick={this.timeSegmentChange}
                      >
                      <p id="annual text-middle" className="text-center">
                        Annual
                      </p>
                    </div>
                    <div className="detail"/>
                    <div className="season-box"
                         value="1"
                         onClick={this.timeSegmentChange}
                      >
                      <p id="winter" className="text-center">
                        Winter
                      </p>
                    </div>
                    <div className="detail"/>
                    <div className="season-box"
                         value="2"
                         onClick={this.timeSegmentChange}
                      >
                      <p id="spring" className="text-center">
                        Spring
                      </p>
                    </div>
                    <div className="detail"/>
                    <div className="season-box"
                         value="3"
                         onClick={this.timeSegmentChange}
                      >
                      <p id="summer" className="text-center">
                        Summer
                      </p>
                    </div>
                    <div className="detail"/>
                    <div className="season-box"
                         value="4"
                         onClick={this.timeSegmentChange}
                      >
                      <p id="fall" className="text-center">
                        Fall
                      </p>
                    </div>
                    <div className="detail"/>
                  </div>
                  <div className="zoom-buttons d-flex ml-auto">
                    <p>Scale</p>
                    <div className="d-flex flex-column">
                      <div id="zoom-out"
                           ref="zoomOut"
                           className="zoom-btn"
                           data-type="minus"
                           onClick={this.zoomOut}
                      >
                        _
                      </div>
                      <div id="zoom-in"
                           ref="zoomIn"
                           className="zoom-btn"
                           data-type="plus"
                           onClick={this.zoomIn}
                      >
                        +
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="summary-box d-flex flex-column">
                <div className="vis-column"/>
                <div className="runner-frame d-flex">
                  <div className="runner-box d-flex flex-column mb-auto">
                    <button id="run-button"
                            className="btn btn-link format-clear"
                            onClick={this.launchModelRun}>
                      Run Model
                    </button>
                    <div className="detail"/>
                  </div>
                </div>
                <div className="spacer"/>
                <div className="d-flex">
                  <div className="summary-frame mt-auto">
                    <div className="history-box d-flex justify-content-center">
                      <div id="prev"
                           ref="prev"
                           className="previous model-hist format-clear"
                           onClick={this.stepHistoryBackward}
                        >
                        &#8249;
                      </div>
                      <p className="mx-2">History</p>
                      <div id="next"
                           ref="next"
                           className="next model-hist format-clear"
                           onClick={this.stepHistoryForward}
                        >
                        &#8250;
                      </div>
                    </div>
                    <p>
                      <br/>
                      <br/>
                      <br/>
                      <br/>
                    </p>
                  </div>
                  <div className="spacer"/>
                  <div className="detail"/>
                </div>
              </div>
            </div>
          </div>
        )
    }
}

export default EmbeddedModel;



// WEBPACK FOOTER //
// ./src/EmbeddedModel.js